import { catalog } from "../i18n.js";

/** The roster rows' previews and times (roster.ts). */
export const ROSTER = catalog(
  {
    justNow: "now",
    minutes: (count: number) => `${count}m`,
    hours: (count: number) => `${count}h`,
    days: (count: number) => `${count}d`,

    photos: (count: number) => (count === 1 ? "Sent a photo" : `Sent ${count} photos`),
    sentFile: (name: string) => `Sent ${name}`,
    you: (text: string) => `You: ${text}`,
    toPeer: (name: string) => `To ${name}`,
    waitingForYou: (summary: string) => `Waiting for you: ${summary}`,
    needsYouOnScreen: (instruction: string) => `Needs you on its screen: ${instruction}`,
    askingYou: (title: string) => `Asking you: ${title}`,
    toBookOrDecline: (text: string) => `To book or decline: ${text}`,
    contactAsks: (name: string, text: string) => `${name} asks: ${text}`,
    contactLeftMessage: (name: string, text: string) => `${name} left a message: ${text}`,
  },
  {
    justNow: "baru saja",
    minutes: (count: number) => `${count}m`,
    hours: (count: number) => `${count}j`,
    days: (count: number) => `${count}h`,

    photos: (count: number) => (count === 1 ? "Mengirim foto" : `Mengirim ${count} foto`),
    sentFile: (name: string) => `Mengirim ${name}`,
    you: (text: string) => `Kamu: ${text}`,
    toPeer: (name: string) => `Ke ${name}`,
    waitingForYou: (summary: string) => `Menunggu kamu: ${summary}`,
    needsYouOnScreen: (instruction: string) => `Butuh kamu di layarnya: ${instruction}`,
    askingYou: (title: string) => `Bertanya ke kamu: ${title}`,
    toBookOrDecline: (text: string) => `Terima atau tolak: ${text}`,
    contactAsks: (name: string, text: string) => `${name} bertanya: ${text}`,
    contactLeftMessage: (name: string, text: string) => `${name} meninggalkan pesan: ${text}`,
  },
);
